<template>
<div class="row plain-element">
    <div v-if="!isLoggedIn()"  class="dashboard-cards">
        <NoPermissionComponent/>
    </div>
   <div v-if="getUsername() && getDivisionPlanData()" class="dashboard">
    <div class="row row-cards">
      <div class="row text-start row-back">
        <a class="back-link" @click="hasHistory() ? $router.go(-1): $router.push('/')">
          <span class="material-icons chevron-left">chevron_left</span> Back To Plan
        </a>
      </div>
    </div>

    <div v-if="getDivisionPlanCarbonTracker()" class="card card-details">
      <p class="error"  v-if="getFormError()">
        <span id="formError">{{ getFormError() }}</span>
      </p>
      <p class="error"  v-else>
      </p>
          <UpdateDivisionPlanCarbonTrackerComponent
              :id = parseInt(id)
              :current_2022 = getDivisionPlanCarbonTracker().current_2022
              :current_2023 = getDivisionPlanCarbonTracker().current_2023
              :current_2024 = getDivisionPlanCarbonTracker().current_2024
              :current_2025 = getDivisionPlanCarbonTracker().current_2025
              :current_2026 = getDivisionPlanCarbonTracker().current_2026
              :current_2027 = getDivisionPlanCarbonTracker().current_2027
              :current_2028 = getDivisionPlanCarbonTracker().current_2028
              :current_2029 = getDivisionPlanCarbonTracker().current_2029
              :current_2030 = getDivisionPlanCarbonTracker().current_2030

        />
    </div>
  </div>
</div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import { hasHistory, truncatechars } from "@/common/general.js";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"
import UpdateDivisionPlanCarbonTrackerComponent from "@/components/division_plans/UpdateDivisionPlanCarbonTrackerComponent.vue";

export default {
  name: "DivisionPlanCarbonTracker",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    NoPermissionComponent,
    UpdateDivisionPlanCarbonTrackerComponent,
  },
  data() {
    return {
      opportunity_list: true,
      climate_graphs: true,
      financial_graphs: true,
      opportunity_details: false

    }
  },
  methods: {
    ...mapGetters(["getDivisionPlanData", "getDivisionPlanCarbonTracker", "getUsername", "isLoggedIn","getFormError"]),
    ...mapActions(["fetchDivisionPlanData", "performSetFormError", "fetchDivisionPlanCarbonTracker"]),
    truncatechars: truncatechars,
    hasHistory: hasHistory,
    getDivisionPlanDetails() {
      this.fetchDivisionPlanData({"id": parseInt(this.id)})
    },
    getDivisionPlanCarbonTrackerDetails() {
      this.fetchDivisionPlanCarbonTracker({"id": parseInt(this.id)})
    }
  },
  computed: {

  },
  created() {
    this.performSetFormError(null);
    this.getDivisionPlanDetails();
    this.getDivisionPlanCarbonTrackerDetails();
    document.title = "Carbon Tracker";
    window.scrollTo(0,0);
  },
  beforeRouteUpdate (to, from, next) {
    this.chosenId = to.params.id;
    this.getDivisionPlanDetails();
    this.getDivisionPlanCarbonTrackerDetails();
    next();
  }

}
</script>

//              :current_active = getDivisionPlanCarbonTracker().active
